(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('DesignTemplateSavedModalCtrl', templateProductSavedModalCtrl);

    function templateProductSavedModalCtrl($scope, $mdDialog, templateId, designId, delayedSet) {
        $scope.templateId = templateId;
        $scope.designId = designId;
        $scope.delayedSet = delayedSet;
        $scope.title = $scope.designId ? 'Design Saved' : 'Design Template Saved';
        $scope.itWillTakeLonger = ' It will take a couple of minutes to appear';
        $scope.yourDesignHasaBeenSaved = 'Your design has been saved.';
        $scope.goToDesignTemplates = function () {
            $mdDialog.hide();
        };
    }
})();
